import './filters-bar.scss';

export default function FiltersBar({ children }) {
  return <div className="filters-bar">{children}</div>;
}

function Row({ children }) {
  return <div className="filters-bar__row">{children}</div>;
}

FiltersBar.Row = Row;
